import employer from "./employer/employer";
import employer_pocs from "./employer/employer_pocs";
import agent_attorney from "./agent_attorney/agent_attorney";
import agent_attorney_individs from "./agent_attorney/agent_attorney_individs";
import foreign_labor from "./foreign_labor_recruiter/foreign_labor";
import crop from "./crop/crop";
import agriculture from "./agriculture/agriculture";
import worker_housing from "./worker_housing/worker_housing";
import material_terms from "./material_terms/material_terms";
import foreign_worker from "./foreign_worker/foreign_worker";
import foreign_worker_group from "./foreign_worker_group/foreign_worker_group";

const FormUISchemaResolver = (formName) => {
  const uischemas = {
    employer: employer,
    "employer-pocs": employer_pocs,
    "agent-attorney": agent_attorney,
    "agent-attorney-individs": agent_attorney_individs,
    "foreign-labor": foreign_labor,
    crop: crop,
    "worker-housing": worker_housing,
    agriculture: agriculture,
    "material-terms": material_terms,
    "foreign-worker": foreign_worker,
    "foreign-worker-group": foreign_worker_group,
  };
  return uischemas[formName] || employer;
};

export default FormUISchemaResolver;
